import type { VoidFunctionComponent } from 'react';

import { BUTTON_SIZE } from '../../../generic';
import Button from '../../../generic/Button';
import FormGroup from '../../../generic/Forms/FormGroup';
import LabeledTextInput from '../../../generic/Forms/LabeledTextInput';
import type { SlackProfileResponse } from '../../../../../shared/model-typings';

type Props = {
  notification: SlackProfileResponse,
  onDisconnect: () => void;
};

const WebhookRow: VoidFunctionComponent<Props> = ({
  notification,
  onDisconnect,
}) =>
  <FormGroup direction="row" spacing="xl" baselineAlignment>
    <LabeledTextInput
      labelVariant="legacy"
      label="Webhook URL"
      value={notification.webhook_url || ''}
      isDisabled
    />
    <LabeledTextInput
      labelVariant="legacy"
      label="Channel"
      value={notification.channel || ''}
      isDisabled
    />
    <Button
      type="error"
      size={BUTTON_SIZE.MEDIUM}
      onClick={onDisconnect}
    >
      Remove
    </Button>
  </FormGroup>;

export default WebhookRow;
